import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LibScrollableComponent } from './lib-scrollable.component';

@NgModule({
  declarations: [LibScrollableComponent],
  imports: [CommonModule],
  exports: [LibScrollableComponent],
})
export class LibScrollableModule {}
